// extracted by mini-css-extract-plugin
export default {"containerCard":"BasicInformation_containerCard__G-dAu","info":"BasicInformation_info__atlgi","title":"BasicInformation_title__3NkIe","section":"BasicInformation_section__KRt91"};